import { config } from '../../../shared'

function parseWebhookUrl(webhookUrl: string) {
  const webhookId = webhookUrl.substring(webhookUrl.lastIndexOf('/') + 1)
  const webhookPrefix = webhookUrl.substring(0, webhookUrl.lastIndexOf('/'))
  return {
    webhookId,
    webhookPrefix,
  }
}

export const formatGmailAuthorizationUrl = (webhookUrl: string) => {
  const { webhookId, webhookPrefix } = parseWebhookUrl(webhookUrl)
  return `https://accounts.google.com/o/oauth2/v2/auth?
scope=https%3A//www.googleapis.com/auth/gmail.send%20https%3A//www.googleapis.com/auth/gmail.readonly&
access_type=offline&
include_granted_scopes=true&
response_type=code&
prompt=consent&
state=${webhookId}&
redirect_uri=${webhookPrefix}/oauth&
client_id=${config.gmailClientId}`.replace(/\n/g, '')
}

export const formatLinearAuthorizationUrl = (webhookUrl: string) => {
  const { webhookId, webhookPrefix } = parseWebhookUrl(webhookUrl)
  return `https://linear.app/oauth/authorize?client_id=${config.linearClientId}&redirect_uri=${webhookPrefix}/oauth&response_type=code&prompt=consent&actor=application&state=${webhookId}&scope=read,write,issues:create,comments:create,admin`
}
